import { observable, action, makeObservable, computed } from 'mobx';

class Focused {
  constructor() {
    makeObservable(this);
  }

  @observable focusedYuxid: string | undefined = '';

  @action
  async setFocusedYuxid(id: string | undefined) {
    this.focusedYuxid = id;
  }
}

export default Focused;
